module.exports = __webpack_public_path__ + "static/img/ms.d7315a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ms.png
// module id = Sxj9
// module chunks = 0